import(/* webpackMode: "eager", webpackExports: ["CalendarEmbed"] */ "/opt/build/repo/components/contact/calendar-embed.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/build/repo/node_modules/next/dist/client/app-dir/link.js");
